import * as React from "react";
import styles from "@/components/Layouts/TopNavbar/Email.module.css";
import {
	IconButton,
	Button,
	Typography,
	Tooltip,
	Menu,
	Link,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const Email = () => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	return (
		<>
			
		</>
	);
};

export default Email;
